import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
const NavbarQuoteDetailStyle = styled('div')`
    .card {
        background-color: var(--white);
        flex-shrink: 0;
        border-radius: 8px;
        box-shadow: rgba(156, 171, 194, 0.4) 4px 4px 20px 0px;
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .box-consultant {
        font-size: 14px;

        .consultant {
            width: 60%;
        }

        p {
            margin-bottom: 5px;
        }
        .golfer {
            color: var(--sand-700);
            font-size: 16px;
            font-weight: 700;
            margin-top: 16px;
        }
        .email {
            color: var(--orange-300);
            text-decoration-line: underline;
        }
        .box-right {
            font-weight: 900;
            color: var(--sand-700);
            text-align: right;
            margin-top: 5px;
        }
    }

    .btn-pay {
        background-color: var(--orange-300) !important;
        width: 100%;
        height: 56px;
        ${typography.buttonLg}
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        color: var(--sand-100);
        margin: 12px 0 4px;
    }

    .btnShare {
        width: 100%;
        height: 56px;
        color: var(--orange-300) !important;
        border-color: var(--orange-300) !important;
        ${typography.buttonMd}
    }

    .navbar {
        ${typography.buttonMd}
        li {
            padding: 3px 0;
            a {
                text-decoration-line: none;
                color: var(--sand-700);
                display: flex;
                align-items: center;
                gap: 6px;
                &:hover {
                    color: var(--orange-300);
                }
                &.active {
                    color: var(--orange-300);
                }
            }
        }
    }

    .mini-basket {
        .reference {
            margin: -1rem -1rem 1rem;
            background: var(--sand-300);
            text-align: center;
            padding: 10px 0;
            border-radius: 8px 8px 0 0;
            font-weight: 600;
        }
    }

    .best-price {
        background: var(--sand-300);
        color: var(--sand-700);
        font-size: 14px;
        line-height: 1.4;
        .img {
            min-width: 103px;
        }
        .title {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: 700;
        }
    }

    .loyalty {
        background: var(--burgundy-800);
        color: var(--white);
        font-size: 14px;
        line-height: 1.4;
        .img {
            min-width: 103px;
            padding-top: 5px;
        }
        .title {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: 700;
        }
        a {
            color: var(--orange-200);
            text-decoration-line: underline;
        }
    }

    .lifetime {
        line-height: 1.4;
        .header {
            font-weight: 700;
            margin-bottom: 6px;
        }

        .input {
            height: 40px;
            padding: 5px;
            border: 2px solid var(--orange-300);
            font-size: inherit;
            font-weight: 900;
            border-radius: 0;
            margin-top: 10px;
            &.ant-input-status-error {
                border-color: #ff4d4f;
            }
        }
    }

    @media screen and (min-width: 1200px) {
        .best-price {
            .title {
                max-width: 185px;
            }
        }
    }

    @media print {
        .card {
            border: 1px solid var(--sand-400);
            box-shadow: none;
        }
    }
`;
export default NavbarQuoteDetailStyle;
